import { Component, OnInit } from '@angular/core';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import {
  ProductsBiocatchEnum,
  StepBiocatchEnum,
} from 'src/app/shared/enums/biocatchContext.enum';
import { Segment } from 'src/app/shared/models/abre-cuentas.model';
import { Changes, TagEvent } from 'src/app/shared/models/dali-tags.model';
import { DocumentModel } from 'src/app/shared/models/document.model';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { ConfigurationService } from 'src/app/shared/services/configuration/configuration.service';
import { CryptoVaultService } from 'src/app/shared/services/external/crypto-vault/crypto-vault.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

import { BUSINESS_CONST } from '../../../shared/constants/business.constants';
import { OpEnum } from '../../../shared/enums/op.enum';
import { CheckboxModel } from '../../../shared/models/common.model';
import { IsPEP } from '../../../shared/models/fi.model';
import { LogDeviceModel } from '../../../shared/models/log-device.model';
import { IProductsModel } from '../../../shared/models/products.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from '../../../shared/services/bitacora/bitacora.service';
import { ChannelCommunicatorService } from '../../../shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { BioCatchService } from '../../../shared/services/external/biocatch/biocatch.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { HelpersService } from '../../../shared/services/helpers/helpers-onboarding.service';
import { ValidationHelperService } from '../../../shared/services/helpers/validation-helper.service';
import { IdentificationService } from '../../../shared/services/identification/identification.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { ProductsService } from '../../../shared/services/products/products.service';
import { SignOnService } from '../../../shared/services/sign-on/sign-on.service';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import { DaliService, IPageLoadModel } from '@dali/tagger-ng8';
import {
  PAGEVIEW as PAGEVIEW_FA,
  CHANNEL as CHANNEL_FA,
  COUNTRY as COUNTRY_FA,
  BUSINNESS as BUSINNESS_FA,
  ENVIRONMENT as ENVIRONMENT_FA,
  FAMILY as FAMILY_FA,
  SUBFAMILY as SUBFAMILY_FA,
  PRODUCT as PRODUCT_FA,
} from 'src/app/shared/constants/dali-fa-tc.constants';
import { EVENT as EVENT_FA_LD } from 'src/app/shared/constants/dali-fa-ld.constants';
import { Subscription } from 'rxjs';

/**./
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
@Component({
  selector: 'app-politically-exposed-person',
  templateUrl: './politically-exposed-person.component.html',
  styleUrls: ['./politically-exposed-person.component.scss'],
})

/**
 * Definición de la clase PoliticallyExposedPersonComponent, validación si un cliente es PEP o no
 *
 * *Defines PoliticallyExposedPersonComponent class, back scan document*
 */
export class PoliticallyExposedPersonComponent implements OnInit {
  /**
   * Mensaje de error
   *
   * *Error message*
   * @access public
   * @type {string}
   */
  customErrorMessage: string;
  /**
   * Valida si el botón esta habilitado o no
   *
   * *Validates if the button is enabled or not*
   * @access public
   * @type {boolean}
   */
  isBtnDisabled = true;
  /**
   * Variable de validación para mostrar modal
   *
   * *Validation variable to showModal*
   *
   * @access public
   * @type {boolean}
   */
  showModal = false;

  /**
   * Objeto de tipo IsPEP
   *
   * *IsPEP object*
   * @access public
   * @type {IsPEP}
   */
  IsPEP = new IsPEP();
  /**
   * Lista de opciones de raddio buttons
   *
   * *Options list for raddio buttons*
   *
   * @access public
   * @type {Array<any>}
   */
  listIsPEP: any[] = [];
  /**
   * Contiene atributos del dispositivo
   *
   * *Has device attributes*
   * @access public
   * @type {LogDeviceModel}
   */
  devicePrint: LogDeviceModel;
  /**
   * Variable de CheckBox de términos y condiciones
   *
   * *CheckBox variable to terms and conditions*
   *
   * @access public
   * @type {CheckboxModel}
   */
  checkboxTerms: CheckboxModel;
  /**
   * Declaración de la variable products como IProductsModel, donde se guardan los productos
   *
   * *Set products variable as IProductsModel, where products list are saved*
   *
   * @access              public
   * @type                {IProductsModel[]}
   */
  products: IProductsModel[];
  /**
   * Variable de validación de términos y condiciones
   *
   * *Validation variable to terms and conditions*
   *
   * @access public
   * @type {any}
   */
  terms: any;
  product_type: string;
  infoDocument = new DocumentModel();
  postLogin: boolean;
  transaction_id: any;
  has_second_headline: any;
  productSelected: any;
  limitedBreak: boolean;
  temproducts: any[] = [];
  descrip: any;
  channelId: string;
  isNewClient: boolean;

  statusSendBackDocument$: Subscription;

  /**
   * Constructor inicial del componente
   *
   * *Component initial constructor*
   * @param {CopyService}
   * @param {NavigationService}
   * @param {AbreCuentasService}
   * @param {BioCatchService}
   * @param {HeaderService}
   * @param {IdentificationService}
   * @param {ParametersService}
   * @param {ChannelCommunicatorService}
   */
  constructor(
    public copyService: CopyService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private bioCatchService: BioCatchService,
    private headerService: HeaderService,
    private identificationService: IdentificationService,
    private parametersService: ParametersService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private taggingServices: TaggingService,
    private signOnService: SignOnService,
    private configurationService: ConfigurationService,
    private requestService: RequestService,
    private productsService: ProductsService,
    private validatorHelperService: ValidationHelperService,
    private bitacoraService: BitacoraService,
    private loaderService: LoaderService,
    private cipherService: CryptoVaultService,
    private helpersService: HelpersService,
    private firmlyApprovedService: FirmlyApprovedService,
    private captureService: CaptureService,
    private daliService: DaliService,
    private taggingService: TaggingService,
  ) {
    this.devicePrint = new LogDeviceModel();
    this.headerService.show(true, true, true);
    this.has_second_headline = this.abreCuentasService.getSecondHeadline()
      ? this.abreCuentasService.getSecondHeadline().has_second_headline
      : false;
  }

  /**
   * Función que se ejecuta cuando de inicia el componente
   *
   * *Executes when component is run*
   */
  async ngOnInit() {
    this.postLogin = this.abreCuentasService.getPostlogin();
    this.infoDocument = this.abreCuentasService.getDocumentInfo();
    this.productSelected = this.abreCuentasService.getproductSelected();
    if (!this.postLogin && this.productSelected.product_type !== BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
      console.warn('Se procederá a validación de Documentos.....');
      await this.validateClientData();
    }
    this.sendTagging('init');
    const isFirmlyApproved = this.firmlyApprovedService.isFirmlyApproved();

    if (isFirmlyApproved && this.abreCuentasService.getProductsSelects().length === 1) {
      this.sendPEPPageLoad();
    }

    this.channelId = this.channelCommunicatorService.getChannelId();
    this.checkBioCatch();
    const product = this.abreCuentasService.getproductSelected()
      .product_code as ProductsBiocatchEnum;
    if (product !== ProductsBiocatchEnum.VIV && !this.bioCatchService.isAppCN()) {
      this.bioCatchService.changeContext(StepBiocatchEnum.identificacion, product,
        this.bioCatchService.isVivCn(product));
    }
    this.transaction_id = this.abreCuentasService.getTransactionId();
    this.product_type = this.productSelected
      ? this.productSelected.product_type
      : '';
    this.listIsPEP = [
      {
        label: this.copyService.copies.identification_pep_yes,
        elementId: 1,
        checked: this.abreCuentasService.getListIsPEP() === this.copyService.copies.identification_pep_yes,
      },
      {
        label: this.copyService.copies.identification_pep_no,
        elementId: 2,
        checked: this.abreCuentasService.getListIsPEP() === this.copyService.copies.identification_pep_no,
      },
    ];
    this.FiProperty();

    if (this.channelId === CHANNEL.PORTALO.CODE) {
      this.postLogin = true;
    }

    if (
      !this.postLogin
    ) {
      return this.enableNextButton();
    }
    this.terms = {
      text: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0]
        .description,
      title: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].code,
      terms_id: this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].id,
    };
    this.checkboxTerms = {
      id: this.terms.terms_id,
      label:
        'Autorizo el tratamiento de mis datos según la siguiente política: ',
      checked: false,
      value: this.terms.terms_id,
    };
    if (!this.has_second_headline) { await this.callClientExistInformationService(); }
    const productType =
      this.abreCuentasService.getproductSelected().product_type;
    if (
      (productType === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
        productType === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
        productType === BUSINESS_CONST.PRODUCT_TYPE_TC ||
        productType === BUSINESS_CONST.MULTI ||
        (this.channelId === CHANNEL.PORTALO.CODE && productType === BUSINESS_CONST.PRODUCT_TYPE_LIVING && !this.isNewClient))
    ) {
      this.keyCipherExchange();
    }

    // Valida si el cliente va por el flujo de aprobados en firme, de ser asi valida sus solicitudes.
    if (isFirmlyApproved) {
      this.validateRequestsGZAF();
    }
    if (!this.abreCuentasService.getPostlogin()) {
      this.encripmethod();
    }
  }

  private validateClientData() {
    const clientData = this.abreCuentasService.getRescueData();
    console.log('Ingresando a la validación de documentos');
    if (clientData.number_id !== this.infoDocument.document_number) {
      console.error('---------------- FRAUDE --------------');
      this.saveBitacora('Documento Escaneado : ' + this.infoDocument.document_number + '- Posible Fraude');
      this.saveBitacora('Identificacion_Coincide_No');
      this.navigationService.navigateToGeneralInformation('102');
    }
    console.log('Validación Exitosa de Documentos');
  }

  private saveBitacora(message: string) {
    this.bitacoraService.saveDataInBitacora(message);
  }

  async encripmethod() {
    await this.cipherService
      .encrypt(
        `${this.abreCuentasService.getDocumentInfo().document_number
        }_${this.abreCuentasService.getDocumentInfo().document_type.replace('0', '')}`,
      )
      .then(data => {
        this.descrip = data;
        console.log(this.descrip);
      });
  }
  /**
   * Validar pais de la persona para aprobados en firme
   *
   * *Validate the person's country for firmly approved
   */
  checkBioCatch() {

    if (!this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
      this.abreCuentasService.showGenericLoading();
      this.bioCatchService.checkCountry(false).then(response => {
        this.abreCuentasService.hideGenericLoading();
        if (!response.data.response && this.bioCatchService.getGeoServiceComplete()) {
          this.navigationService.navigateToGeneralInformation('dsbException');
        } else {
          const biocatchInfo: any = this.bioCatchService.getBiocatchInfo();
          if (biocatchInfo && !!biocatchInfo.ipGeoCity && !!biocatchInfo.ipGeoCountry) {
            const bitacoraEventGeo = `geo_biocatch_${biocatchInfo.ipGeoCity}_${biocatchInfo.ipGeoCountry}`;
            this.bitacoraService.saveDataInBitacora(bitacoraEventGeo);
          }
        }
      }, () => {
        this.abreCuentasService.hideGenericLoading();
        this.navigationService.navigateToGeneralInformation('500');
      }).catch(() => this.navigationService.navigateToGeneralInformation('500'));
    }
  }

  async productChannel() {
    const arrayProduct: any[] =
      this.parametersService.getSetting('productPolitical');
    const requestData = await this.captureService.getRequestsByClient(this.descrip);
    if (this.abreCuentasService.getproductSelected().product_type === 'multi') {
      let multiGrayZone = false;
      this.abreCuentasService.getProductsSelects().forEach((el: any) => {
        if (this.captureService.maProduct(requestData, el.product_type)) {
          console.log('datos');
          multiGrayZone = true;
        }
      });
      if (multiGrayZone) {
        this.navigationService.navigateToGeneralInformation('129');
        this.bitacoraService.saveDataInBitacora('pending_process');
      }
    } else if (
      arrayProduct.includes(
        this.abreCuentasService.getproductSelected().product_type,
      )
    ) {
      if (
        this.captureService.maProduct(
          requestData,
          this.abreCuentasService.getproductSelected().product_type,
        )
      ) {
        this.navigationService.navigateToGeneralInformation('129');
        if (this.postLogin === true) {
          this.navigationService.pageLoadTag('ErrorProcesoEnTramite', ['pv426', '', 'pv572', '']);
        }
        console.log('AQUI');
        this.bitacoraService.saveDataInBitacora('pending_process');
        return true;
      }
    }
    return false;
  }

  async keyCipherExchange() {
    console.warn('Entró en PEP por keyCipherExchange ------');
    const limitMaxProducts = this.parametersService.getSetting(
      OpEnum.MAX_COUNT_PRODUCTS,
    );
    await this.requestService
      .clientProduct()
      .then(async (res: any) => {
        console.log('PEP ------->>>>> ClientProduct: ', res);
        if (res.body.data.length > 0) {
          const productType = this.abreCuentasService.getproductSelected().product_type;
          if (this.channelId === CHANNEL.PORTALO.CODE && productType === BUSINESS_CONST.PRODUCT_TYPE_LIVING && !this.has_second_headline) {
            this.abreCuentasService.setPostlogin(true);
          }
          if (
            this.abreCuentasService.getproductSelected().product_type !==
            BUSINESS_CONST.MULTI
          ) {
            res.body.data.forEach(record => {
              if (
                record.product_type != null &&
                record.product_number != null &&
                record.product_sub_type != null
              ) {
                // if (
                //   this.abreCuentasService.getproductSelected().product_type !==
                //   BUSINESS_CONST.PRODUCT_TYPE_TC &&
                //   this.abreCuentasService.getproductSelected().product_type !==
                //   BUSINESS_CONST.PRODUCT_TYPE_FREE &&
                //   this.validatorHelperService.validationOfProductDuplicity(
                //     this.cipherService.decrypt(record.product_sub_type),
                //   )
                // ) {
                //   this.navigationService.navigateToGeneralInformation('514');
                //   window.stop();
                //   this.loaderService.forceHide();
                //   return;
                // }
                record.product_type = this.cipherService.decrypt(
                  record.product_type,
                );
                record.product_number = this.cipherService.decrypt(
                  record.product_number,
                );
                record.product_sub_type = this.cipherService.decrypt(
                  record.product_sub_type,
                );
              }
              return;
            });
            if (this.abreCuentasService.getproductSelected().product_type ===
              BUSINESS_CONST.PRODUCT_TYPE_FREE) {
              const products_ord = this.countProductsOrd(res);
              if (products_ord.length >= limitMaxProducts.ORD) {
                this.sendToErrorProducts();
                return;
              }
            }
          }

          if (this.abreCuentasService.viewOptionMultiProduct) {
            res.body.data.forEach(record => {
              if (
                record.product_type != null &&
                record.product_number != null &&
                record.product_sub_type != null
              ) {
                record.product_type = this.cipherService.decrypt(
                  record.product_type,
                );
                record.product_number = this.cipherService.decrypt(
                  record.product_number,
                );
                record.product_sub_type = this.cipherService.decrypt(
                  record.product_sub_type,
                );
              }
              return;
            });
            console.log('productos', res.body.data);
          }

          if (
            this.abreCuentasService.getproductSelected().product_type ===
            BUSINESS_CONST.PRODUCT_TYPE_TC
          ) {
            const products_tc = res.body.data.filter(
              (products: { product_type: string }) => {
                return products.product_type === 'TCR';
              },
            );
            if (products_tc.length >= limitMaxProducts.TCR) {
              this.navigationService.navigateToGeneralInformation('514');
              return;
            }
          }

          if (
            this.abreCuentasService.getproductSelected().product_type ===
            BUSINESS_CONST.MULTI
          ) {
            const products_tc = res.body.data.filter(products => {
              // Tarjeta de credito
              return products.product_type === 'TCR';
            });
            const products_ord = res.body.data.filter(products => {
              // Credito personal
              return (
                products.product_type === 'ORD' &&
                this.parametersService
                  .getSetting(OpEnum.ABRE_CUENTAS_CONFIGS)[0]
                  .blockedProductsByProductCode.freeInvestment.filter(
                    fil => fil === products.product_sub_type,
                  )
              );
            });
            const products_crp = res.body.data.filter(products => {
              // Credito rotativo
              return (
                products.product_type === 'CRP' &&
                this.parametersService
                  .getSetting(OpEnum.ABRE_CUENTAS_CONFIGS)[0]
                  .blockedProductsByProductCode.revolvingCredit.filter(
                    fil => fil === products.product_sub_type,
                  )
              );
            });
            const products_lib = res.body.data.filter(products => {
              // Credito libranza
              return products.product_type === 'LIB';
            });
            if (
              products_tc.length >= limitMaxProducts.TCR &&
              products_ord.length >= limitMaxProducts.ORD &&
              products_crp.length >= limitMaxProducts.CRP &&
              products_lib.length >= limitMaxProducts.LIB
            ) {
              this.navigationService.navigateToGeneralInformation('514');
              return;
            } else {
              const productsSelects = this.abreCuentasService.getProductsSelects();
              productsSelects.forEach((product: any) => {
                if (product.product_code === 'ORD') {
                  if (products_ord.length >= limitMaxProducts.ORD) {
                    this.temproducts.push(product);
                  }
                }
                if (product.product_code === 'TCR') {
                  if (products_tc.length >= limitMaxProducts.TCR) {
                    this.temproducts.push(product);
                  }
                }
                if (product.product_code === 'CRP') {
                  if (products_crp.length >= limitMaxProducts.CRP) {
                    this.temproducts.push(product);
                  }
                }
                if (product.product_code === 'LBR') {
                  if (products_lib.length >= limitMaxProducts.LIB) {
                    this.temproducts.push(product);
                  }
                }
              });
              // if (this.abreCuentasService.getFlowLoan()) {
              //   this.flowLoan(res.body.data);
              // }
              console.log('this.temproducts.length', this.temproducts.length);
              console.log('this.productsSelects.length', productsSelects.length);
              if (this.temproducts.length === productsSelects.length) {
                this.navigationService.navigateToGeneralInformation('514');
              } else if (this.temproducts.length > 0) {
                this.abreCuentasService.setProductsMax(this.temproducts);
                this.navigationService.nextStep('302');
              }
            }
          }

          res.body.data = res.body.data.filter(products => {
            return (
              products.product_type !== 'CRP' &&
              products.product_type !== 'ORD' &&
              products.product_type !== 'TCR'
            );
          });
          const productsShow = this.filterClassProduc(res.body.data);
          if (productsShow.length > 0) {
            this.abreCuentasService.setClientProduct(true);
            this.abreCuentasService.setListClientProduct(productsShow);
          } else {
            this.abreCuentasService.setClientProduct(false);
          }
        }
        return;
      })
      .catch(error => {
        if (error && error.status === 422) {
          const regExpRemoveMSString = /\|\s*MS$/;
          const errorResponse = error.error && error.error.message
            ? JSON.parse(error.error.message.replace(regExpRemoveMSString, ''))
            : undefined;
          const errorUserNotInSecutiryDb = this.parametersService.getSetting(OpEnum.ERROR_USER_NOT_IN_SECURITY_DB);
          if (errorResponse && errorResponse.Status.statusDesc === errorUserNotInSecutiryDb) {
            this.isNewClient = true;
            return this.enableNextButton();
          }
        }
        this.navigationService.navigateToGeneralInformation('127');
      });
    // this.navigationService.pageLoadTag('ErrorNoEsPosibleContinuar', ['pv425', '', 'pv573', '']);
  }

  /**
   * Filtrar productos no habilitados para transacciones.
   */
  filterClassProduc(body) {
    let products = body;
    const no_transaction = this.parametersService.getSetting(OpEnum.NO_TRANSACTION_PRODUCTS);
    no_transaction.forEach(element => {
      products = products.filter(product => product.product_sub_type !== element);
    });
    return products;
  }

  flowLoan(data: any) {
    console.log('data', data);
    const products_tc = data.filter((products: { product_type: string; }) => {
      let tcr = this.cipherService.decrypt(products.product_type);
      return tcr === 'TCR';
    });
    const products_cr = data.filter((products: { product_type: string; }) => {
      return products.product_type === 'CRP';
    });
    const products_lib = data.filter((products: { product_type: string; product_sub_type: string }) => {
      return products.product_type === 'ORD' && products.product_sub_type === '371'
        || products.product_sub_type === '382' || products.product_sub_type === '439';
    });
    console.log('prueba lib', products_lib);
    console.log('prueba cr', products_cr);
    console.log('prueba tc', products_tc);
    // if (this.abreCuentasService.getFlowLoan() &&
    // this.abreCuentasService.getAgreementDetailSelected().agreement_operation_flag === BUSINESS_CONST.AGREEMENT_OPERATION_FLAG_SI) {
    //   this.navigationService.navigateToGeneralInformation('134');
    // } else if (this.abreCuentasService.getAgreementDetailSelected().agreement_operation_flag === BUSINESS_CONST.AGREEMENT_OPERATION_FLAG_NO) {
    //   this.navigationService.navigateToGeneralInformation('514');
    // }
  }

  // TCR

  /**
   * Carga datos predefinidos para la variable IsPEP
   *
   * *Charges predefined data by attribute IsPEP
   */
  getData() {
    const additional_information =
      this.abreCuentasService.getCustomerData().basic.additional_information[0];
    const information = additional_information.key === 'Es Usted PEP?';
    const pep = information === true ? 'si' : 'no';
    this.FiProperty();
  }

  FiProperty() {
    this.IsPEP = {
      elementId: 2,
      value: 'No',
      checked: true,
    };
    if (this.has_second_headline) {
      this.abreCuentasService.setFiPropertySecondHeadline('IsPEP', this.IsPEP);
      this.IsPEP = this.abreCuentasService.getFiPropertySecondHeadline('IsPEP');
      return;
    }
    this.abreCuentasService.setFiProperty('IsPEP', this.IsPEP);
    this.IsPEP = this.abreCuentasService.getFiProperty('IsPEP');
  }
  /**
   * Valida si el botón del componente esta habilitado o no
   *
   * *Validates is the button component is enabled or not*
   */
  enableNextButton() {
    this.isBtnDisabled = false;
  }

  /**
   * Se ejecuta cuando se selecciona una opción de la lista
   *
   * *Executes when an option list is selected*
   * @param event
   */
  selectPEP(event: any) {
    this.IsPEP = {
      elementId:
        event.value === this.copyService.copies.identification_pep_yes ? 1 : 2,
      value: event.value,
      checked: true,
    };

    this.has_second_headline
      ? this.abreCuentasService.setFiPropertySecondHeadline('IsPEP', this.IsPEP)
      : this.abreCuentasService.setFiProperty('IsPEP', this.IsPEP);
  }

  /**
   * Evento para cambiar el estado de checkbox y establece la propiedad
   *
   * *Summary Event to change checkbox and set Prop*
   *
   * @param {any} event
   */
  checkboxChange(event: any): void {
    if (event.checked) {
      this.isBtnDisabled = false;
    } else {
      this.isBtnDisabled = true;
    }
    this.checkboxTerms.checked = event.checked;
    this.has_second_headline
      ? this.abreCuentasService.setFiPropertySecondHeadline(
        'checkboxTerms',
        this.checkboxTerms,
      )
      : this.abreCuentasService.setFiProperty(
        'checkboxTerms',
        this.checkboxTerms,
      );
  }

  downloadPdf() {
    this.channelCommunicatorService
      .getImpl()
      .openPdf(
        this.parametersService.getSetting(OpEnum.DATA_POLICY_OP)[0].pdfUrl,
      );
  }

  /**
   * Servicio para enviar datos a Google analytics
   *
   * *Send data to Google Analytics*
   */
  toggleModal(clickEvent) {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    try {
      const changes: Changes[] = [
        {
          path: EVENT[`${tagPageName}E1setData`][
            `${tagPageName}E1transactionDetailsProductcategory`
          ].path,
          value:
            EVENT[`${tagPageName}E1setData`][
              `${tagPageName}E1transactionDetailsProductcategory`
            ].value,
        },
        {
          path: EVENT[`${tagPageName}E1setData`][
            `${tagPageName}E1transactionName`
          ].path,
          value:
            EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionName`]
              .value,
        },
      ];
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module.body,
          type: EVENT.customCategory.type.link,
          position: EVENT.customCategory.position.top,
        },
        action: EVENT.customAction.click,
        label: EVENT[`${tagPageName}E1customLabel`],
      };
      this.taggingServices.pageTagEvent(event, changes);
    } catch (error) {
      console.log(`Error en. ${error}`);
    }
    switch (clickEvent.type) {
      case 'primary':
        this.downloadPdf();
        break;
      case 'click':
        this.showModal = true;
        this.navigationService.pageLoadTag(false, ['pv5', 'pv109', 'pv69', '']);
        break;
      case 'close':
        this.showModal = false;
        break;
      default:
        break;
    }
  }

  /**
   * Se ejecuta cuando se da clic en el botón continuar el componente
   *
   * *It executes when the burron continue in the component is clicked*
   */
  async next() {

    this.sendTagging('next', 'bottom', '2');
    if (this.taggingServices.isFirmlyAprovedMono()) {
      this.sendContinueButtonEvent();
    }
    // await this.productChannel();
    this.abreCuentasService.setListIsPEP(this.IsPEP.value);
    const bitacoraEvent = `is_pep_${this.IsPEP.value}`;
    this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    const bitacoraEventTerms = 'term_condition_accept';
    this.bitacoraService.saveDataInBitacora(bitacoraEventTerms);
    console.log('PEP >>> next');
    if (this.abreCuentasService.getUserJemelii() && this.abreCuentasService.getproductSelected().product_type !==
    BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
      this.navigationService.nextStep('201');
    } else {
      this.navigationService.nextStep('200');
    }
  }

  async callClientExistInformationService() {
    const documentInfo = this.abreCuentasService.getDocumentInfo();
    /*const parms = {
      issusedIdentType: documentInfo.document_type,
      issusedIdentValue: documentInfo.document_number,
    };*/

    const parms = {
      data: {
        document: {
          number: documentInfo.document_number,
          type: documentInfo.document_type,
        },
      },
    };
    await this.identificationService
      .getClientInformation(parms)
      .then((resp: any) => {
        if (resp) {
          if (resp.status === 200) {
            if (
              (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
                this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING) &&
              !this.ageValidation(resp.body.data.basic.birthdate)
            ) {
              this.navigationService.navigateToGeneralInformation('106');
              return;
            }
            this.abreCuentasService.setProspectResponse({ client: true });
            const data = resp.body.data.basic;
            this.abreCuentasService.setCustomerData(resp.body.data);
            this.validatorHelperService.setCustomerDataClient();
            this.getData();

            const item = data.additional_information.find(
              (x: any) => x.key === 'Fecha Expedición Documento Identidad',
            );

            this.infoDocument.date_of_issue = item.name;
            this.infoDocument.sex = data.gender;
            this.infoDocument.firstname = data.given_names[0];
            this.infoDocument.middlename = data.given_names[1];
            this.infoDocument.primary_lastname = data.family_names[0];
            this.infoDocument.second_lastname = data.family_names[1];
            this.infoDocument.birthdate = data.birthdate;
            this.abreCuentasService.setDocumentInfo(this.infoDocument);
            const segmentId = resp.body.data.basic.sub_segment_id;
            const products = this.abreCuentasService.getProductsSelects();
            const validProduct = products.filter(fil => fil.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE);
            if (this.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE
              || validProduct.length > 0) {
              this.validateSegment(segmentId);
            } else if (
              this.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING
            ) {
              this.bitacoraService.saveDataInBitacora(
                `${segmentId}_${this.helpersService.getProductCodeBySegmentId(
                  segmentId,
                )}`,
              );
            }
            if (this.product_type !== BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
              this.callProspect();
            }
          } else {
            this.abreCuentasService.caseInfoError('512');
            this.navigationService.nextStep('103');
          }
        }
        return;
      })
      .catch(error => {
        if (error && error.status === 422) { // Cuando no encuentre usuario
          this.isNewClient = true;
          return this.enableNextButton();
        }
        this.navigationService.navigateToGeneralInformation('512');
        this.navigationService.pageLoadTag('ErrorQueremosConocerte', ['pv440', '', 'pv576', '']);
      });
  }

  ageValidation(birthDateString) {
    if (!birthDateString) {
      return false;
    }
    const actualDate = new Date();
    const birthDate = new Date(birthDateString);
    let age = actualDate.getFullYear() - birthDate.getFullYear();
    const month = actualDate.getMonth() - birthDate.getMonth();
    if (
      month < 0 ||
      (month === 0 && actualDate.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    const maxAgeLimit = this.parametersService.getBusinessRule('max_age_limit');
    return age < maxAgeLimit;
  }

  validateSegment(segment: string) {
    const availableSegments: Segment[] =
      this.abreCuentasService.getAbreCuentasConfigs().available_segments;
    const avaliableSegment = availableSegments.find(e => e.code === segment);
    if (avaliableSegment && avaliableSegment.valid) {
      return;
    }
    this.navigationService.navigateToGeneralInformation('126');
  }

  async callProspect() {
    let document_type = '';
    switch (this.infoDocument.document_type) {
      case '02':
      case '03':
        document_type = 'CC';
        break;
      case 'I3':
        document_type = 'TI';
        break;
      default:
        document_type = 'CC';
        break;
    }

    const info = new DocumentModel();
    info.birthdate = this.infoDocument.birthdate.split('-').join('/');
    info.document_number = this.infoDocument.document_number;
    info.document_type = document_type;
    info.firstname = this.infoDocument.firstname;
    info.middlename = this.infoDocument.middlename;
    info.primary_lastname = this.infoDocument.primary_lastname;
    info.second_lastname = this.infoDocument.second_lastname;
    info.sex = this.infoDocument.sex;
    this.identificationService.sendBackDocumentInfo(info);
    this.statusSendBackDocument$ = this.identificationService.statusSendBackDocument$.subscribe((status: any) => {
      if (status.error) {
        this.navigationService.navigateToGeneralInformation(status.code);
      } else {
        this.navigationService.nextStep(status.code);
      }

      this.statusSendBackDocument$.unsubscribe();
    });
  }

  async validateRequestsGZAF() {
    const documentId = `${this.abreCuentasService.getDocumentInfo().document_number}_${this.abreCuentasService
      .getDocumentInfo().document_type.replace('0', '')}`;
    await this.firmlyApprovedService.validateRequestsGZ(documentId).then(result => {
      if (result.code !== '200') {
        const bitacoraEvent = `afmulti_pending_process`;
        this.bitacoraService.saveDataInBitacora(bitacoraEvent);
        this.navigationService.navigateToGeneralInformation(result.code);
        return;
      }
      // tslint:disable-next-line:early-exit
      if (result.code === '200' && result.data.length > 0) {
        switch (this.abreCuentasService.getproductSelected().product_type) {
          // TODO: Implementar en esta parte el llamado al servicio para apagar la vitrina.
          case 'freeInvestment':
            const bitacoraEventFree = 'afcp_pending_process';
            this.bitacoraService.saveDataInBitacora(bitacoraEventFree);
            break;
          case 'creditCard':
            const bitacoraEventTC = 'aftc_pending_process';
            this.bitacoraService.saveDataInBitacora(bitacoraEventTC);
            break;
          case 'revolvingCredit':
            const bitacoraEventRv = 'afcr_pending_process';
            this.bitacoraService.saveDataInBitacora(bitacoraEventRv);
            break;
          default:
            break;
        }
        this.navigationService.navigateToGeneralInformation('129');
        return;
      }
    }).catch(() => {
      const bitacoraEvent = `afmulti_pending_process`;
      this.bitacoraService.saveDataInBitacora(bitacoraEvent);
      this.navigationService.navigateToGeneralInformation('107');
    });
  }
  countProductsOrd(response: any): any {
    return response.body.data.filter(products_free => {
      // Credito personal
      return (
        products_free.product_type === BUSINESS_CONST.PRODUCT_CODE_ORD &&
        this.parametersService
          .getSetting(OpEnum.ABRE_CUENTAS_CONFIGS)[0]
          .blockedProductsByProductCode.freeInvestment.filter(
            filter => filter === products_free.product_sub_type,
          )
      );
    });
  }

  async sendToErrorProducts() {
    this.navigationService.navigateToGeneralInformation('514');
    window.stop();
    this.loaderService.forceHide();

  }

  /* ------------- Taggeo ------------- */

  /* ------------ Taggeo - PageLoad ------------ */
  sendPEPPageLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const productsType = {
      ORD: 'LD',
      TCR: 'TC',
    };
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA.pv1pageName.path,
        value: `${isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking}:${COUNTRY_FA.co}:${BUSINNESS_FA.pf}:${ENVIRONMENT_FA.loggeado}:${FAMILY_FA.services}:${SUBFAMILY_FA.request}:${PRODUCT_FA.request}:${PAGEVIEW_FA.pv1pageName.value}`,
      },
      {
        path: PAGEVIEW_FA.pv1pageFamily.path,
        value: PAGEVIEW_FA.pv1pageFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv1subFamily.path,
        value: PAGEVIEW_FA.pv1subFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv1pageAction.path,
        value: PAGEVIEW_FA.pv1pageAction.value,
      },
      {
        path: PAGEVIEW_FA.pv1pageid.path,
        value: PoliticallyExposedPersonComponent.name,
      },
      {
        path: PAGEVIEW_FA.pv1transactionName.path,
        value: `${PAGEVIEW_FA.pv1transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`,
      },
      {
        path: PAGEVIEW_FA.pv1transactionTransactionStep.path,
        value: PAGEVIEW_FA.pv1transactionTransactionStep.value,
      },
    ];
    this.taggingServices.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }
  /* ------------ Taggeo - Events ------------ */

  sendBackButtonEvent(): void {
    this.sendTagging('prev', 'bottom', '1');
    if (!this.taggingServices.isFirmlyAprovedMono()) {
      return;
    }
    const data = [
      {
        path: EVENT_FA_LD.pv1E2setData.pv1E2transactionTransactionStep.path,
        value: EVENT_FA_LD.pv1E2setData.pv1E2transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv1E2setData.pv1E2transactionName.path,
        value: `${EVENT_FA_LD.pv1E2setData.pv1E2transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`, // cambiar valor segun sea LD o TC
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.bottom,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv1E2customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendContinueButtonEvent(): void {
    const data = [
      {
        path: EVENT_FA_LD.pv1E3setData.pv1E3transactionTransactionStep.path,
        value: EVENT_FA_LD.pv1E3setData.pv1E3transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv1E3setData.pv1E3clientElegibility.path,
        value: this.IsPEP.value === 'Sí' ? 'EsPEP' : 'NoEsPEP',
      },
      {
        path: EVENT_FA_LD.pv1E3setData.pv1E3transactionName.path,
        value: `${EVENT_FA_LD.pv1E3setData.pv1E3transactionName.value.slice(0, -2)}${this.taggingServices.getProductFlow()}`, // cambiar valor segun sea LD o TC
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.bottom,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv1E3customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendTagging(value: any, position?: string, event?: string) {
    const page = '2';
    const extras = {
      object: 'clientElegibility',
      value: this.IsPEP.value == 'No' ? 'NoEresPEP ' : 'EresPEP',
      pageValue: 'PoliticallyExposedPerson',
    };
    this.taggingService.sendTaggValues(value, page, position, event, extras);
  }
}
